import { Soya } from "soya-js";

// soya is created only once
// this way we can make use of its inbuilt caching
export const soya = new Soya();